interface BadgeProps {
    variant: 'pro' | 'pro-quiet' | 'count' | 'tab-count' | 'status' | 'current-plan';
    children: React.ReactNode;
}

const VARIANTS: Record<BadgeProps['variant'], string> = {
    // On the dark sidebar.
    pro: 'bg-white/15 text-leaf-pill text-[10px] font-bold px-2 py-0.5',
    // On a white panel.
    'pro-quiet': 'bg-leaf-tint text-heading text-[10.5px] font-bold px-[9px] py-[3px]',
    count: 'bg-leaf-pill text-sidebar text-[11px] font-bold px-2 py-px',
    // The mobile tab bar's Enquiries badge — a solid leaf pill rather than the pale `count` tint,
    // because it sits over a small icon rather than a headline number on a card.
    'tab-count': 'bg-leaf text-white text-[9.5px] font-bold leading-4 text-center min-w-4 h-4 px-[3px]',
    // The Enquiries inbox row badge (NEW/HANDLED/WON/LOST). The prototype only ever draws NEW, in
    // exactly this tint — there is no second colour given for the other three statuses, so rather
    // than invent one, every status shares this one recipe and differs only by its label. Same
    // numbers as `pro-quiet` by coincidence (both happen to be the prototype's badge-on-white
    // shape), kept as a separate variant because the two have nothing to do with each other
    // semantically and must be free to diverge later.
    status: 'bg-leaf-tint text-sidebar text-[11px] font-bold px-[9px] py-[3px]',
    // The plan page's CURRENT PLAN marker, straddling the top edge of whichever plan card is the
    // active one. Same leaf-pill-on-sidebar-green pair as `count`, but wider padding and the
    // prototype's letter-spacing, because this one carries a word rather than a single digit — and
    // it has to read as legible small-caps on the dark card as well as on the white one.
    'current-plan': 'bg-leaf-pill text-sidebar text-[11px] font-bold tracking-[0.06em] px-3.5 py-[5px]',
};

export default function Badge({ variant, children }: BadgeProps) {
    return <span className={`rounded-full ${VARIANTS[variant]}`}>{children}</span>;
}
